// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__uF8oe","inputWrap":"styles_inputWrap__1d80h","input":"styles_input__3Qr8k"};